import React from "react";
import { cn } from "../../styles";
import { PeakLogo } from "./PeakLogo";
import { StyledContainerProps } from "../../props";
import { AppBarNavigation, AppBarLink } from "./Navigation";
import { AppBarDarkModeButton } from "./DarkModeButton";

export type { AppBarNavigationProps, AppBarLinkProps } from "./Navigation";
export type { AppBarDarkModeButtonProps } from "./DarkModeButton";
export { PeakLogo } from "./PeakLogo";

export interface AppBarProps extends StyledContainerProps {
  /** Logo or branding element */
  logo?: React.ReactNode;

  /** Main navigation content */
  navigation?: React.ReactNode;

  /** Right-side actions (theme toggle, user menu, etc.) */
  actions?: React.ReactNode;

  /** Fixed height for the app bar */
  height?: number | string;
}

export const AppBar = ({
  className,
  height = 56,
  logo = <PeakLogo />,
  navigation,
  actions,
  children,
}: AppBarProps) => (
  <header
    className={cn(
      "shrink-0 flex items-stretch bg-back-100 dark:bg-back-800 border-b border-back-200 dark:border-back-700 z-[1200] shadow-sm px-6",
      className
    )}
    style={{ height }}
  >
    {logo && <div className="shrink-0 flex items-center mr-6">{logo}</div>}

    <div className="flex-1 min-w-0 ">
      <div className="max-w-full h-full">{navigation}</div>
    </div>

    {actions && (
      <div className="shrink-0 flex items-center gap-2 ml-6">{actions}</div>
    )}
    {children}
  </header>
);

AppBar.Navigation = AppBarNavigation;
AppBar.Link = AppBarLink;
AppBar.DarkModeButton = AppBarDarkModeButton;
